// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__2DKhT","header":"NotFound_header__15D84","message":"NotFound_message__1itYP","link":"NotFound_link__22Uww"};